import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';

/**
 * Dialogue de confirmation générique et réutilisable (warning + action danger).
 * Utilisé pour les suppressions (planche, zone…) afin de ne pas dupliquer un bouton/dialogue partout.
 */
@Component({
  selector: 'vw-confirm-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, SharedModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() message = '';
  @Input() confirmLabel = '';
  @Input() cancelLabel = '';
  @Input() danger = true;
  @Input() loading = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
